import { ReactNode } from 'react';
import { CalculationExpUtil } from '../../../../../../../../../utils/descriptor/calculationExp';
import { ImportDescriptorIdType } from '../../../../../../types';
import { useImportTableStoreDescriptor } from '../../../../context/importTableContext';
import { getImportTableRowStyling } from './utils';
import { useHighlightsStoreActions } from '../../../../../../stores/highlightStore';

type ImportTableRowPropsType = {
    descriptorId: ImportDescriptorIdType;
    highlightedVariables: ImportDescriptorIdType[];
    handleHighLightCalcVariables: (ids: ImportDescriptorIdType[]) => void;
    handleUnhighLightCalcVariables: () => void;
    children: ReactNode;
};

function ImportTableRow({
    descriptorId,
    handleHighLightCalcVariables,
    handleUnhighLightCalcVariables,
    highlightedVariables,
    children,
}: ImportTableRowPropsType) {
    const descriptor = useImportTableStoreDescriptor(descriptorId);
    const { styles, classes } = getImportTableRowStyling(descriptor, highlightedVariables);
    const highlightActions = useHighlightsStoreActions();
    return (
        <tr
            key={descriptor.id}
            style={styles}
            className={classes}
            onPointerEnter={() => {
                if (descriptor.verticalCalculation !== CalculationExpUtil.NO_OP_CALC) {
                    handleHighLightCalcVariables(CalculationExpUtil.getIncludedIds(descriptor.verticalCalculation));
                }
                highlightActions.setDescriptorId(descriptor.masterDescriptorId);
            }}
            onPointerLeave={() => {
                handleUnhighLightCalcVariables();
                highlightActions.setDescriptorId(null);
            }}
        >
            {children}
        </tr>
    );
}

export default ImportTableRow;
